import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';
import { string } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';
import Icon from '../Icon/Icon';

const propTypes = {
  type: string,
};

const DomainDisclaimer = () => (
  <Alert className="domain-disclaimer" color="primary">
    <Icon type="warning" className="text-danger" />
    <span className="font-weight-bolder text-danger">
      {' '}
      <FormattedMessage id="main.attension" defaultMessage="Attention" />
    </span>{' '}
    <FormattedMessage
      id="domains.tutorial.disclaimer"
      defaultMessage="Register NS records for one example.com domain only once, and all the top.example.com subdomains can simply be added to our system without any changes on the registrar's side."
    />
    <a className="domains-tutorial--faq-link" href={`/faq/tools/parking`} target="_blank">
      <FormattedMessage id="domains.tutorial.faq_link" defaultMessage="" />
    </a>
  </Alert>
);

DomainDisclaimer.propTypes = propTypes;

export default DomainDisclaimer;
